import React from "react";

/** Animated lightning bolt SVG used throughout the site. */
export function BoltIcon({ className = "", color = "#FF6B00" }) {
  return (
    <svg
      viewBox="0 0 24 32"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M14 0L0 18h8L6 32 22 12h-8l2-12z"
        fill={color}
        stroke="#0F4C75"
        strokeWidth="0.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Hero background: grid + floating bolts + abstract gradient blobs + flowing paths */
export function ElectricBackground({ className = "" }) {
  return (
    <div
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      aria-hidden="true"
    >
      {/* gradient base */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0F4C75] via-[#0F4C75] to-[#1B262C]" />

      {/* animated grid */}
      <div className="absolute inset-0 grid-bg opacity-70" />

      {/* blurred orange blob */}
      <div
        className="absolute -right-24 -bottom-24 w-[520px] h-[520px] rounded-full blur-3xl opacity-40"
        style={{
          background:
            "radial-gradient(closest-side, rgba(255,107,0,0.7), transparent 70%)",
        }}
      />
      {/* blurred cyan/secondary blob */}
      <div
        className="absolute -left-32 top-10 w-[460px] h-[460px] rounded-full blur-3xl opacity-50"
        style={{
          background:
            "radial-gradient(closest-side, rgba(50,130,184,0.7), transparent 70%)",
        }}
      />

      {/* flowing electric paths */}
      <svg
        className="absolute inset-0 w-full h-full"
        viewBox="0 0 1200 700"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="flow1" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#FF6B00" stopOpacity="0" />
            <stop offset="50%" stopColor="#FF6B00" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#3282B8" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="flow2" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#3282B8" stopOpacity="0" />
            <stop offset="50%" stopColor="#3282B8" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#FF6B00" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M-20 560 C 200 500, 300 640, 520 560 S 900 440, 1220 520"
          stroke="url(#flow1)"
          strokeWidth="2"
          fill="none"
          className="dash-flow"
        />
        <path
          d="M-20 220 C 220 140, 420 300, 620 220 S 960 100, 1220 180"
          stroke="url(#flow2)"
          strokeWidth="2"
          fill="none"
          className="dash-flow"
          style={{ animationDelay: "-2s" }}
        />
      </svg>

      {/* floating bolts */}
      <BoltIcon
        className="absolute top-[12%] right-[14%] w-8 h-10 float-slow bolt-flicker"
        color="#FF6B00"
      />
      <BoltIcon
        className="absolute top-[60%] right-[38%] w-6 h-8 float-slower bolt-flicker"
        color="#FFB341"
      />
      <BoltIcon
        className="absolute top-[28%] left-[8%] w-5 h-7 float-slower bolt-flicker"
        color="#FF6B00"
      />

      {/* noise overlay */}
      <div className="absolute inset-0 noise" />
    </div>
  );
}

/** Small electric arc divider */
export function ArcDivider({ className = "" }) {
  return (
    <svg
      viewBox="0 0 200 12"
      className={className}
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="arc-grad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#0F4C75" />
          <stop offset="50%" stopColor="#FF6B00" />
          <stop offset="100%" stopColor="#0F4C75" />
        </linearGradient>
      </defs>
      <path
        d="M0 6 L40 6 L50 2 L60 10 L70 4 L80 8 L90 6 L200 6"
        stroke="url(#arc-grad)"
        strokeWidth="1.6"
        fill="none"
      />
    </svg>
  );
}
